"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8321],{

/***/ 51965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
// TODO: Refac codewise + design
const react_1 = __importDefault(__webpack_require__(11720));
const building_blocks_ui_common_1 = __webpack_require__(22567);
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  min-height: 26px;
`;
const BounceAnimation = (0, building_blocks_ui_common_1.keyframes) `
  0% { margin-bottom: 0; }
  50% { margin-bottom: 15px }
  100% { margin-bottom: 0 }
`;
const Dot = building_blocks_ui_common_1.styled.div `
  background-color: #fff;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  /* Animation */
  animation: ${BounceAnimation} 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s
    infinite both;
  /* animation: ${BounceAnimation} 0.5s linear infinite; */
  animation-delay: ${(props) => props.delay};
`;
const LoadingDots = () => {
    return (react_1.default.createElement(Container, { alignItems: "flex-end", justifyContent: "center" },
        react_1.default.createElement(Dot, { delay: "0s" }),
        react_1.default.createElement(Dot, { delay: ".1s" }),
        react_1.default.createElement(Dot, { delay: ".2s" })));
};
exports["default"] = LoadingDots;
//# sourceMappingURL=button-loader.js.map

/***/ }),

/***/ 16806:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DarkButton = exports.TertiaryButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
const react_1 = __importDefault(__webpack_require__(11720));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const styles_1 = __webpack_require__(45714);
const button_loader_1 = __importDefault(__webpack_require__(51965));
function Button({ children, 
// size controls the line height and font-size of the children inside the button
size, disabled, loading, onClick, styledButton, isTransparent, isFullWidth, }) {
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const StyledButton = styledButton ||
        function () {
            return null;
        };
    return (react_1.default.createElement(StyledButton, { disabled: disabled, theme: theme, colors: colors, className: size, onClick: onClick, isTransparent: isTransparent, isFullWidth: isFullWidth, loading: loading }, loading ? react_1.default.createElement(button_loader_1.default, null) : children));
}
const PrimaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonPrimary })));
exports.PrimaryButton = PrimaryButton;
const SecondaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonSecondary })));
exports.SecondaryButton = SecondaryButton;
const TertiaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonTertiary })));
exports.TertiaryButton = TertiaryButton;
const DarkButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonDark })));
exports.DarkButton = DarkButton;
//# sourceMappingURL=button.js.map

/***/ }),

/***/ 2518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonText = exports.DarkButton = exports.TertiaryButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
var button_1 = __webpack_require__(16806);
Object.defineProperty(exports, "PrimaryButton", ({ enumerable: true, get: function () { return button_1.PrimaryButton; } }));
Object.defineProperty(exports, "SecondaryButton", ({ enumerable: true, get: function () { return button_1.SecondaryButton; } }));
Object.defineProperty(exports, "TertiaryButton", ({ enumerable: true, get: function () { return button_1.TertiaryButton; } }));
Object.defineProperty(exports, "DarkButton", ({ enumerable: true, get: function () { return button_1.DarkButton; } }));
var button_2 = __webpack_require__(26774);
Object.defineProperty(exports, "ButtonText", ({ enumerable: true, get: function () { return button_2.ButtonText; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonText = exports.StyledButton = void 0;
const building_blocks_ui_typography_1 = __webpack_require__(29829);
const styled_components_1 = __importDefault(__webpack_require__(10063));
var paddingSizeEnum;
(function (paddingSizeEnum) {
    paddingSizeEnum["large"] = "11px 0px";
    paddingSizeEnum["medium"] = "7px 0px";
    paddingSizeEnum["small"] = "5px 0px";
    // 1px disperency in extra small due to animation height
    paddingSizeEnum["extra-small"] = "4px 0px";
    paddingSizeEnum["undefined"] = "11px 0px";
})(paddingSizeEnum || (paddingSizeEnum = {}));
exports.StyledButton = styled_components_1.default.button `
  cursor: pointer;
  width: 100%;
  align-items: center;
  // adding padding due to loading button size disperency
  padding: ${(props) => !props.loading ? props.theme.spacing[2] + ' ' + props.theme.spacing[4] : paddingSizeEnum[props.className]};
  border-radius: ${(props) => props.theme.border.radius.large};
  font-family: ${(props) => props.theme.typography.fonts.family.family};
  font-weight: ${(props) => props.theme.typography.fonts.weight.T4_SB};
  line-height: ${(props) => props.theme.typography.lineHeights.H3};
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  &.large {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 117px')};
    line-height: ${(props) => props.theme.typography.lineHeights.H3};
    font-size: ${(props) => props.theme.typography.fonts.size.P1};
  }
  &.medium {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T2};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T4_SB};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.extra-small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    /* TODO - line height 14px doesn't exist in style guides - putting 16px here */
    line-height: ${(props) => props.theme.typography.lineHeights.C1};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
`;
exports.ButtonText = (0, styled_components_1.default)(building_blocks_ui_typography_1.Text) `
    color: #ffffff;
    font-weight: 500;
    font-size: height: ${props => (props.fontSize ? props.fontSize : '16px')};
    line-height: 18px;
`;
//# sourceMappingURL=button.js.map

/***/ }),

/***/ 41692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonDark = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
const button_1 = __webpack_require__(26774);
exports.StyledButtonDark = (0, styled_components_1.default)(button_1.StyledButton) `
  border: none;
  color: ${(props) => props.colors.primary.n0};
  background-color: ${(props) => props.colors.primary.n600};

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=dark-button.js.map

/***/ }),

/***/ 45714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonDark = exports.StyledButtonTertiary = exports.StyledButtonSecondary = exports.StyledButtonPrimary = void 0;
var primary_button_1 = __webpack_require__(82097);
Object.defineProperty(exports, "StyledButtonPrimary", ({ enumerable: true, get: function () { return primary_button_1.StyledButtonPrimary; } }));
var secondary_button_1 = __webpack_require__(24146);
Object.defineProperty(exports, "StyledButtonSecondary", ({ enumerable: true, get: function () { return secondary_button_1.StyledButtonSecondary; } }));
var tertiary_button_1 = __webpack_require__(57035);
Object.defineProperty(exports, "StyledButtonTertiary", ({ enumerable: true, get: function () { return tertiary_button_1.StyledButtonTertiary; } }));
var dark_button_1 = __webpack_require__(41692);
Object.defineProperty(exports, "StyledButtonDark", ({ enumerable: true, get: function () { return dark_button_1.StyledButtonDark; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonPrimary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
const button_1 = __webpack_require__(26774);
exports.StyledButtonPrimary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: none;
  color: ${(props) => props.colors.primary.n0};
  background-color: ${(props) => props.colors.green.g300};

  // adding hover state only in DWeb view
  @media (min-width: 768px) {
    &:hover {
      background-color: ${(props) => props.colors.green.g400};
    }
  }

  &:active {
    background-color: ${(props) => props.colors.green.g500};
  }

  &:disabled {
    pointer-events: none;
    background-color: ${(props) => props.colors.neutral.n300};
  }
`;
//# sourceMappingURL=primary-button.js.map

/***/ }),

/***/ 24146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonSecondary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
const button_1 = __webpack_require__(26774);
exports.StyledButtonSecondary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: 1px solid ${(props) => props.colors.primary.n600};
  color: ${(props) => props.colors.primary.n600};
  background-color: ${(props) => props.isTransparent ? 'transparent' : props.colors.primary.n0};

  &:hover {
    background-color: ${(props) => props.colors.neutral.n50};
  }

  &:active {
    background-color: ${(props) => props.colors.neutral.n200};
  }

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=secondary-button.js.map

/***/ }),

/***/ 57035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonTertiary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
const button_1 = __webpack_require__(26774);
exports.StyledButtonTertiary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: 1px solid ${(props) => props.colors.red.r400};
  color: ${(props) => props.colors.red.r400};
  background-color: ${(props) => props.colors.primary.n0};

  &:hover {
    background-color: ${(props) => props.colors.red.r50};
  }

  &:active {
    background-color: ${(props) => props.colors.red.r100};
  }

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=tertiary-button.js.map

/***/ }),

/***/ 22567:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styled = void 0;
__exportStar(__webpack_require__(6447), exports);
__exportStar(__webpack_require__(13069), exports);
__exportStar(__webpack_require__(86453), exports);
var styled_components_1 = __webpack_require__(6447);
Object.defineProperty(exports, "styled", ({ enumerable: true, get: function () { return __importDefault(styled_components_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServerStyleSheet = exports.styledComponents = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
//@ts-nocheck
const styledComponents = __importStar(__webpack_require__(10063));
exports.styledComponents = styledComponents;
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, ServerStyleSheet, } = styledComponents;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.ServerStyleSheet = ServerStyleSheet;
const Styled = styled;
exports["default"] = Styled;
//# sourceMappingURL=styled-components.js.map

/***/ }),

/***/ 13069:
/***/ (function(__unused_webpack_module, exports) {


/**
<<<<<<< HEAD
* ======================
* Break Points
* ======================
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.$fontWeightBolder = exports.$fontWeightBold = exports.$fontWeightNormal = exports.$fontWeightLight = exports.$primaryColorsGreen = exports.$fontSize = exports.$space = exports.$blackShades = exports.$greyShades = exports.$greenShades = exports.$backgroundColor = exports.$white = exports.$grayLighter = exports.$grayLight = exports.$hyperlink = exports.$error = exports.$info = exports.$warning = exports.$neutralColors = exports.$accentColors = exports.$primaryColors = exports.$fontFamily = exports.$containerXsL = exports.$screenL = exports.$screenXsL = exports.$screenXs = exports.$containerXs = exports.$gutter = void 0;
exports.$gutter = 16;
exports.$containerXs = '28.125em';
exports.$screenXs = '30em';
exports.$screenXsL = '40em';
exports.$screenL = '48em';
exports.$containerXsL = '38.125em';
/**
 * ==========
 * Font family
 * ==========
 */
exports.$fontFamily = "'Inter', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
/**
 * ==========
 * Colors
 * ==========
 */
exports.$primaryColors = {
    lightest: '#DDD4F8',
    light: '#9174E7',
    normal: '#582CDB',
    dark: '#421EAE',
};
exports.$accentColors = {
    lightest: '#D4F7E6',
    light: '#7EE7B4',
    normal: '#44CB86',
    dark: '#1FAD69',
};
exports.$neutralColors = {
    lightest: '#DCDCE0',
    light: '#8D8E99',
    normal: '#5C5D66',
    dark: '#151619',
};
exports.$warning = '#FF9100';
exports.$info = '#697890';
exports.$error = '#FD4B44';
exports.$hyperlink = '#3C8CEA';
exports.$grayLight = '#F3F3F7';
exports.$grayLighter = '#F3F7FF';
exports.$white = '#FFFFFF';
exports.$backgroundColor = exports.$grayLight;
exports.$greenShades = {
    normal: '#37C87E',
    dark: '#00A871',
};
exports.$greyShades = {
    normal: '#C8D0DB',
};
exports.$blackShades = {
    normal: '#434F5A',
    dark: '#282E33',
};
/**
 * ==========
 * Spacing
 * ==========
 */
exports.$space = {
    xs: '0.5em',
    s: '1em',
    sm: '1.5em',
    m: '2em',
    l: '3em',
    xl: '4em',
    xxl: '6em',
};
/**
 * ==========
 * font
 * ==========
 */
exports.$fontSize = {
    xxxs: '0.625rem',
    xxs: '0.75rem',
    xs: '0.875rem',
    normal: '1rem',
    small: '1.125rem',
    medium: '1.25rem',
    large: '1.5rem',
    xl: '1.875rem',
    xxl: '2.375rem',
    xxxl: '2.875rem', // 46px
};
exports.$primaryColorsGreen = {
    disabled: '#E5E5E5',
    lightest: '#f2faf7',
    light: '#0FA457',
    normal: '#0FA457',
    dark: '#149452',
};
/**
 * ==========
 * Font weights
 * ==========
 */
exports.$fontWeightLight = 400;
exports.$fontWeightNormal = 500;
exports.$fontWeightBold = 600;
exports.$fontWeightBolder = 700;
exports["default"] = {};
//# sourceMappingURL=theme.js.map

/***/ }),

/***/ 86453:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = exports.Box = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
exports.Box = styled_components_1.default.div `
  width: ${props => (props.width ? props.width : "100%")};
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent}` : ""};
  ${props => (props.alignItems ? `align-items: ${props.alignItems}` : "")};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : "")};
  ${props => (props.margin ? `margin: ${props.margin}` : "")};
  ${props => (props.padding ? `padding: ${props.padding}` : "")};
  ${props => (props.mt ? `margin-top: ${props.mt}` : "")};
  ${props => (props.mr ? `margin-right: ${props.mr}` : "")};
  ${props => (props.mb ? `margin-bottom: ${props.mb}` : "")};
  ${props => (props.ml ? `margin-left: ${props.ml}` : "")};
  ${props => (props.pt ? `padding-top: ${props.pt}` : "")};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : "")};
  ${props => (props.pl ? `padding-left: ${props.pl}` : "")};
  ${props => (props.pr ? `padding-right: ${props.pr}` : "")};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : "")};
  ${props => props.styles};
`;
exports.Flex = (0, styled_components_1.default)(exports.Box) `
  display: flex;
  ${props => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ""};
  ${props => props.styles};
`;
exports["default"] = {};
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 13632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H5 = building_blocks_ui_common_1.styled.h5 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.medium,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
  white-space: pre-wrap;
`;
exports["default"] = H5;
//# sourceMappingURL=headingFive.js.map

/***/ }),

/***/ 37291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H4 = building_blocks_ui_common_1.styled.h4 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.large,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H4;
//# sourceMappingURL=headingFour.js.map

/***/ }),

/***/ 54489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H1 = building_blocks_ui_common_1.styled.h1 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xxxl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H1;
//# sourceMappingURL=headingOne.js.map

/***/ }),

/***/ 58539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H7 = building_blocks_ui_common_1.styled.h6 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xs,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H7;
//# sourceMappingURL=headingSeven.js.map

/***/ }),

/***/ 83169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H6 = building_blocks_ui_common_1.styled.h6 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.normal,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H6;
//# sourceMappingURL=headingSix.js.map

/***/ }),

/***/ 69786:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H3 = building_blocks_ui_common_1.styled.h3 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H3;
//# sourceMappingURL=headingThree.js.map

/***/ }),

/***/ 56736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const H2 = building_blocks_ui_common_1.styled.h2 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xxl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H2;
//# sourceMappingURL=headingTwo.js.map

/***/ }),

/***/ 28660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const H4 = building_blocks_ui_common_1.styled.h4 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H4',
    defaultFontWeight: 'H4',
    defaultLineHeight: 'H4',
})}
  `;
exports["default"] = H4;
//# sourceMappingURL=heading-four.js.map

/***/ }),

/***/ 65949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const H1 = building_blocks_ui_common_1.styled.h1 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H1',
    defaultFontWeight: 'H1',
    defaultLineHeight: 'H1'
})}
  `;
exports["default"] = H1;
//# sourceMappingURL=heading-one.js.map

/***/ }),

/***/ 80730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const H3 = building_blocks_ui_common_1.styled.h3 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H3',
    defaultFontWeight: 'H3',
    defaultLineHeight: 'H3'
})}
  `;
exports["default"] = H3;
//# sourceMappingURL=heading-three.js.map

/***/ }),

/***/ 50299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const H2 = building_blocks_ui_common_1.styled.h2 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H2',
    defaultFontWeight: 'H2',
    defaultLineHeight: 'H2',
})}
  `;
exports["default"] = H2;
//# sourceMappingURL=heading-two.js.map

/***/ }),

/***/ 30307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getStyles = void 0;
const building_blocks_ui_common_1 = __webpack_require__(70727);
const defaultStyle = "H1";
const getStyles = ({ defaultFontSize = defaultStyle, defaultFontWeight = defaultStyle, defaultLineHeight = defaultStyle, }) => props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { styles } = props || {};
    const _r = styles || {}, { fontWeight, color, fontSize, lineHeight } = _r, restStyles = __rest(_r, ["fontWeight", "color", "fontSize", "lineHeight"]);
    return (0, building_blocks_ui_common_1.css) `
    font-weight: ${fontWeight || ((_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.fonts) === null || _c === void 0 ? void 0 : _c.weight) === null || _d === void 0 ? void 0 : _d[defaultFontWeight])};
    color: ${color || ((_h = (_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.light) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.n600)};
    font-size: ${fontSize || ((_m = (_l = (_k = (_j = props === null || props === void 0 ? void 0 : props.theme) === null || _j === void 0 ? void 0 : _j.typography) === null || _k === void 0 ? void 0 : _k.fonts) === null || _l === void 0 ? void 0 : _l.size) === null || _m === void 0 ? void 0 : _m[defaultFontSize])};
    line-height: ${lineHeight || ((_q = (_p = (_o = props === null || props === void 0 ? void 0 : props.theme) === null || _o === void 0 ? void 0 : _o.typography) === null || _p === void 0 ? void 0 : _p.lineHeights) === null || _q === void 0 ? void 0 : _q[defaultLineHeight])};
    ${(props === null || props === void 0 ? void 0 : props.center) && "text-align: center"};
    ${Object.assign({}, restStyles)}
  `;
};
exports.getStyles = getStyles;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 29829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.C1 = exports.P2_L = exports.P2 = exports.P1 = exports.T4_SB = exports.T4_M = exports.T3 = exports.T2 = exports.T1 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Price = exports.Text = exports.SubHeading = exports.H7 = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const headingOne_1 = __importDefault(__webpack_require__(54489));
exports.H1 = headingOne_1.default;
const headingTwo_1 = __importDefault(__webpack_require__(56736));
exports.H2 = headingTwo_1.default;
const headingThree_1 = __importDefault(__webpack_require__(69786));
exports.H3 = headingThree_1.default;
const headingFour_1 = __importDefault(__webpack_require__(37291));
exports.H4 = headingFour_1.default;
const headingFive_1 = __importDefault(__webpack_require__(13632));
exports.H5 = headingFive_1.default;
const headingSix_1 = __importDefault(__webpack_require__(83169));
exports.H6 = headingSix_1.default;
const headingSeven_1 = __importDefault(__webpack_require__(58539));
exports.H7 = headingSeven_1.default;
const subHeading_1 = __importDefault(__webpack_require__(79852));
exports.SubHeading = subHeading_1.default;
const text_1 = __importDefault(__webpack_require__(28973));
exports.Text = text_1.default;
const priceText_1 = __importDefault(__webpack_require__(50273));
exports.Price = priceText_1.default;
// Headings
const heading_one_1 = __importDefault(__webpack_require__(65949));
exports.Heading1 = heading_one_1.default;
const heading_two_1 = __importDefault(__webpack_require__(50299));
exports.Heading2 = heading_two_1.default;
const heading_three_1 = __importDefault(__webpack_require__(80730));
exports.Heading3 = heading_three_1.default;
const heading_four_1 = __importDefault(__webpack_require__(28660));
exports.Heading4 = heading_four_1.default;
// Title 
const title_one_1 = __importDefault(__webpack_require__(92905));
exports.T1 = title_one_1.default;
const title_two_1 = __importDefault(__webpack_require__(4103));
exports.T2 = title_two_1.default;
const title_three_1 = __importDefault(__webpack_require__(77057));
exports.T3 = title_three_1.default;
const title_four_1 = __importDefault(__webpack_require__(87988));
exports.T4_M = title_four_1.default;
const title_four_semi_bold_1 = __importDefault(__webpack_require__(50875));
exports.T4_SB = title_four_semi_bold_1.default;
// Paragraph And Caption
const para_one_1 = __importDefault(__webpack_require__(57584));
exports.P1 = para_one_1.default;
const para_two_1 = __importDefault(__webpack_require__(37382));
exports.P2 = para_two_1.default;
const para_two_light_1 = __importDefault(__webpack_require__(46718));
exports.P2_L = para_two_light_1.default;
const caption_one_1 = __importDefault(__webpack_require__(34849));
exports.C1 = caption_one_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 34849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const C1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'C1',
    defaultFontWeight: 'C1',
    defaultLineHeight: 'C1'
})}
  `;
exports["default"] = C1;
//# sourceMappingURL=caption-one.js.map

/***/ }),

/***/ 57584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const P1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P1',
    defaultFontWeight: 'P1',
    defaultLineHeight: 'P1'
})}
  `;
exports["default"] = P1;
//# sourceMappingURL=para-one.js.map

/***/ }),

/***/ 46718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const P2_L = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P2_L',
    defaultFontWeight: 'P2_L',
    defaultLineHeight: 'P2_L'
})}
  `;
exports["default"] = P2_L;
//# sourceMappingURL=para-two-light.js.map

/***/ }),

/***/ 37382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const P2 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P2',
    defaultFontWeight: 'P2',
    defaultLineHeight: 'P2'
})}
  `;
exports["default"] = P2;
//# sourceMappingURL=para-two.js.map

/***/ }),

/***/ 50273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const Price = building_blocks_ui_common_1.styled.span `
  text-decoration: ${props => (props.strikeThrough ? "line-through" : "")};
  font-weight: ${props => (props.strikeThrough ? "" : building_blocks_ui_common_1.$fontWeightNormal)};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  margin-right: 0.5em;
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
  &:before {
    content: "\\20B9";
  }
`;
exports["default"] = Price;
//# sourceMappingURL=priceText.js.map

/***/ }),

/***/ 79852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const SubHeading = building_blocks_ui_common_1.styled.p `
  ${(0, utils_1.getStyles)({
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
`;
exports["default"] = SubHeading;
//# sourceMappingURL=subHeading.js.map

/***/ }),

/***/ 28973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(86014);
const Text = building_blocks_ui_common_1.styled.p `
  ${(0, utils_1.getStyles)({
    fontWeight: building_blocks_ui_common_1.$fontWeightNormal,
    color: building_blocks_ui_common_1.$neutralColors.dark
})};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
  ${props => props && props.fontWeight && `font-weight: ${props.fontWeight}`};
  ${props => props.styles}
`;
exports["default"] = Text;
//# sourceMappingURL=text.js.map

/***/ }),

/***/ 50875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const T4_SB = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T4_SB',
    defaultFontWeight: 'T4_SB',
    defaultLineHeight: 'T4_SB'
})}
  `;
exports["default"] = T4_SB;
//# sourceMappingURL=title-four-semi-bold.js.map

/***/ }),

/***/ 87988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const T4_M = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T4_M',
    defaultFontWeight: 'T4_M',
    defaultLineHeight: 'T4_M'
})}
  `;
exports["default"] = T4_M;
//# sourceMappingURL=title-four.js.map

/***/ }),

/***/ 92905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const T1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T1',
    defaultFontWeight: 'T1',
    defaultLineHeight: 'T1',
})}
  `;
exports["default"] = T1;
//# sourceMappingURL=title-one.js.map

/***/ }),

/***/ 77057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const T3 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T3',
    defaultFontWeight: 'T3',
    defaultLineHeight: 'T3'
})}
  `;
exports["default"] = T3;
//# sourceMappingURL=title-three.js.map

/***/ }),

/***/ 4103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(70727);
const utils_1 = __webpack_require__(30307);
const T2 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T2',
    defaultFontWeight: 'T2',
    defaultLineHeight: 'T2'
})}
  `;
exports["default"] = T2;
//# sourceMappingURL=title-two.js.map

/***/ }),

/***/ 86014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getStyles = exports.getFontColorVariant = exports.getFontSize = void 0;
const building_blocks_ui_common_1 = __webpack_require__(70727);
function getFontSize(size) {
    return building_blocks_ui_common_1.$fontSize[size || "normal"];
}
exports.getFontSize = getFontSize;
function getFontColorVariant(colorVariant) {
    let fontColor;
    switch (colorVariant) {
        case "primary":
            fontColor = building_blocks_ui_common_1.$primaryColors.normal;
            break;
        case "accent":
            fontColor = building_blocks_ui_common_1.$accentColors.normal;
            break;
        case "neutral":
            fontColor = building_blocks_ui_common_1.$neutralColors.normal;
            break;
        case "error":
            fontColor = building_blocks_ui_common_1.$error;
            break;
        case "hyperlink":
            fontColor = building_blocks_ui_common_1.$hyperlink;
            break;
        case "white":
            fontColor = building_blocks_ui_common_1.$white;
            break;
        case "light":
            fontColor = building_blocks_ui_common_1.$neutralColors.light;
            break;
        default:
            fontColor = building_blocks_ui_common_1.$neutralColors.dark;
    }
    return fontColor;
}
exports.getFontColorVariant = getFontColorVariant;
const getStyles = ({ fontSize, fontWeight, color }) => props => {
    return (0, building_blocks_ui_common_1.css) `
    font-weight: ${fontWeight};
    color: ${props && props.color ? props.color : color};
    margin: 0;
    ${fontSize && `font-size: ${fontSize}`};
    ${props && props.center && "text-align: center"};
  `;
};
exports.getStyles = getStyles;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 70727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styled = void 0;
__exportStar(__webpack_require__(81295), exports);
__exportStar(__webpack_require__(86817), exports);
__exportStar(__webpack_require__(91180), exports);
var styled_components_1 = __webpack_require__(81295);
Object.defineProperty(exports, "styled", ({ enumerable: true, get: function () { return __importDefault(styled_components_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 81295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServerStyleSheet = exports.styledComponents = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
//@ts-nocheck
const styledComponents = __importStar(__webpack_require__(10063));
exports.styledComponents = styledComponents;
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, ServerStyleSheet, } = styledComponents;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.ServerStyleSheet = ServerStyleSheet;
const Styled = styled;
exports["default"] = Styled;
//# sourceMappingURL=styled-components.js.map

/***/ }),

/***/ 86817:
/***/ (function(__unused_webpack_module, exports) {


/**
<<<<<<< HEAD
* ======================
* Break Points
* ======================
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.$fontWeightBolder = exports.$fontWeightBold = exports.$fontWeightNormal = exports.$fontWeightLight = exports.$primaryColorsGreen = exports.$fontSize = exports.$space = exports.$blackShades = exports.$greyShades = exports.$greenShades = exports.$backgroundColor = exports.$white = exports.$grayLighter = exports.$grayLight = exports.$hyperlink = exports.$error = exports.$info = exports.$warning = exports.$neutralColors = exports.$accentColors = exports.$primaryColors = exports.$fontFamily = exports.$containerXsL = exports.$screenL = exports.$screenXsL = exports.$screenXs = exports.$containerXs = exports.$gutter = void 0;
exports.$gutter = 16;
exports.$containerXs = '28.125em';
exports.$screenXs = '30em';
exports.$screenXsL = '40em';
exports.$screenL = '48em';
exports.$containerXsL = '38.125em';
/**
 * ==========
 * Font family
 * ==========
 */
exports.$fontFamily = "'Inter', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";
/**
 * ==========
 * Colors
 * ==========
 */
exports.$primaryColors = {
    lightest: '#DDD4F8',
    light: '#9174E7',
    normal: '#582CDB',
    dark: '#421EAE',
};
exports.$accentColors = {
    lightest: '#D4F7E6',
    light: '#7EE7B4',
    normal: '#44CB86',
    dark: '#1FAD69',
};
exports.$neutralColors = {
    lightest: '#DCDCE0',
    light: '#8D8E99',
    normal: '#5C5D66',
    dark: '#151619',
};
exports.$warning = '#FF9100';
exports.$info = '#697890';
exports.$error = '#FD4B44';
exports.$hyperlink = '#3C8CEA';
exports.$grayLight = '#F3F3F7';
exports.$grayLighter = '#F3F7FF';
exports.$white = '#FFFFFF';
exports.$backgroundColor = exports.$grayLight;
exports.$greenShades = {
    normal: '#37C87E',
    dark: '#00A871',
};
exports.$greyShades = {
    normal: '#C8D0DB',
};
exports.$blackShades = {
    normal: '#434F5A',
    dark: '#282E33',
};
/**
 * ==========
 * Spacing
 * ==========
 */
exports.$space = {
    xs: '0.5em',
    s: '1em',
    sm: '1.5em',
    m: '2em',
    l: '3em',
    xl: '4em',
    xxl: '6em',
};
/**
 * ==========
 * font
 * ==========
 */
exports.$fontSize = {
    xxxs: '0.625rem',
    xxs: '0.75rem',
    xs: '0.875rem',
    normal: '1rem',
    small: '1.125rem',
    medium: '1.25rem',
    large: '1.5rem',
    xl: '1.875rem',
    xxl: '2.375rem',
    xxxl: '2.875rem', // 46px
};
exports.$primaryColorsGreen = {
    disabled: '#E5E5E5',
    lightest: '#f2faf7',
    light: '#0FA457',
    normal: '#0FA457',
    dark: '#149452',
};
/**
 * ==========
 * Font weights
 * ==========
 */
exports.$fontWeightLight = 400;
exports.$fontWeightNormal = 500;
exports.$fontWeightBold = 600;
exports.$fontWeightBolder = 700;
exports["default"] = {};
//# sourceMappingURL=theme.js.map

/***/ }),

/***/ 91180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = exports.Box = void 0;
const styled_components_1 = __importDefault(__webpack_require__(10063));
exports.Box = styled_components_1.default.div `
  width: ${props => (props.width ? props.width : "100%")};
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent}` : ""};
  ${props => (props.alignItems ? `align-items: ${props.alignItems}` : "")};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : "")};
  ${props => (props.margin ? `margin: ${props.margin}` : "")};
  ${props => (props.padding ? `padding: ${props.padding}` : "")};
  ${props => (props.mt ? `margin-top: ${props.mt}` : "")};
  ${props => (props.mr ? `margin-right: ${props.mr}` : "")};
  ${props => (props.mb ? `margin-bottom: ${props.mb}` : "")};
  ${props => (props.ml ? `margin-left: ${props.ml}` : "")};
  ${props => (props.pt ? `padding-top: ${props.pt}` : "")};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : "")};
  ${props => (props.pl ? `padding-left: ${props.pl}` : "")};
  ${props => (props.pr ? `padding-right: ${props.pr}` : "")};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : "")};
  ${props => props.styles};
`;
exports.Flex = (0, styled_components_1.default)(exports.Box) `
  display: flex;
  ${props => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ""};
  ${props => props.styles};
`;
exports["default"] = {};
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 41219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uu": function() { return /* binding */ MONTH_SHORT_FORMS; },
/* harmony export */   "gg": function() { return /* binding */ MONTHS; },
/* harmony export */   "z1": function() { return /* binding */ DAYS; }
/* harmony export */ });
/* unused harmony export VIEWS */
var MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
];
var MONTH_SHORT_FORMS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
];
var DAYS = [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
];
var VIEWS = {
    DATES: "date",
    MONTH: "month",
    YEAR: "year"
};


/***/ }),

/***/ 1165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ handleBrowserBack; },
/* harmony export */   "Fw": function() { return /* binding */ calculateAge; },
/* harmony export */   "Jw": function() { return /* binding */ getDomainHostname; },
/* harmony export */   "L0": function() { return /* binding */ getTravellersLabel; },
/* harmony export */   "L6": function() { return /* binding */ getTripDurationLabel; },
/* harmony export */   "So": function() { return /* binding */ getYear; },
/* harmony export */   "ZH": function() { return /* binding */ getSessionQuery; },
/* harmony export */   "Zu": function() { return /* binding */ getLabelWithCount; },
/* harmony export */   "bV": function() { return /* binding */ getAtlPrice; },
/* harmony export */   "jw": function() { return /* binding */ getMonth; },
/* harmony export */   "kp": function() { return /* binding */ convertDateRange; },
/* harmony export */   "m4": function() { return /* binding */ getImageBasePath; },
/* harmony export */   "pI": function() { return /* binding */ getDurationString; },
/* harmony export */   "rf": function() { return /* binding */ redirectToLogin; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; },
/* harmony export */   "xN": function() { return /* binding */ convertDateToString; },
/* harmony export */   "yd": function() { return /* binding */ getFormattedDates; }
/* harmony export */ });
/* unused harmony exports getLabel, convertDateFormat, getCountriesString, getSegmentCountries, getUserType, inputRegexValidation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _segment_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19659);
/* harmony import */ var _api_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66725);
/* harmony import */ var src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56073);
/* harmony import */ var src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41219);







var getImageBasePath = function(imagePath) {
    var imageStaticPath =  true ? "https://internet-travel-retail-frontend.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
    var basePath = imageStaticPath ? "".concat(imageStaticPath, "/_next_static") : "/_next_static";
    if (basePath === "/_next_static") {
        return imagePath;
    }
    return "".concat(basePath).concat(imagePath);
};
var getLabel = function() {
    var label = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedCountries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var length = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.length;
    if (length > 0) {
        var ref;
        var filtered = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.filter(function(_, i) {
            return i < 2;
        });
        label = (ref = filtered === null || filtered === void 0 ? void 0 : filtered.map(function(param) {
            var name = param.name;
            return name;
        })) === null || ref === void 0 ? void 0 : ref.join(", ");
        if (length > 2) return label.concat(" and ".concat(length - 2, " more"));
    }
    return label;
};
var getLabelWithCount = function() {
    var selectedCountries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var label = "";
    var length = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.length;
    if (length > 0) {
        var ref;
        var filtered = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.filter(function(_, i) {
            return i < count;
        });
        label = (ref = filtered === null || filtered === void 0 ? void 0 : filtered.map(function(param) {
            var name = param.name;
            return name;
        })) === null || ref === void 0 ? void 0 : ref.join(", ");
        if (length > count) return label.concat(" +".concat(length - count));
    }
    return label;
};
var getTravellersLabel = function() {
    var adultCount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, seniorCitizenCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, childCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var stringList = [];
    var adultString = adultCount > 0 ? adultCount > 1 ? "".concat(adultCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.ADULT */ .WD.ADULT, "s") : "".concat(adultCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.ADULT */ .WD.ADULT) : "";
    if (adultString) stringList === null || stringList === void 0 ? void 0 : stringList.push(adultString);
    var childString = childCount > 0 ? childCount > 1 ? "".concat(childCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.CHILDREN */ .WD.CHILDREN) : "".concat(childCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.CHILD */ .WD.CHILD) : "";
    if (childString) stringList === null || stringList === void 0 ? void 0 : stringList.push(childString);
    var seniorString = seniorCitizenCount > 0 ? seniorCitizenCount > 1 ? "".concat(seniorCitizenCount, " senior citizens") : "".concat(seniorCitizenCount, " senior citizen") : "";
    if (seniorString) stringList === null || stringList === void 0 ? void 0 : stringList.push(seniorString);
    return stringList === null || stringList === void 0 ? void 0 : stringList.join(", ");
};
var convertDateFormat = function(date) {
    var formattedDate = moment(date).format("DD-MM-YYYY");
    return formattedDate;
};
var getCountriesString = function() {
    var countries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref, ref1;
    var names = (ref = countries === null || countries === void 0 ? void 0 : countries.map(function(c) {
        return c === null || c === void 0 ? void 0 : c.name;
    })) === null || ref === void 0 ? void 0 : ref.join(", ");
    if ((names === null || names === void 0 ? void 0 : names.length) > 30) return (ref1 = names === null || names === void 0 ? void 0 : names.substring(0, 30)) === null || ref1 === void 0 ? void 0 : ref1.concat("...");
    return names;
};
var getDurationString = function(start, end) {
    var nStart = moment__WEBPACK_IMPORTED_MODULE_0___default()(start, "DD-MM-YYYY").format("D MMM YYYY");
    var nEnd = moment__WEBPACK_IMPORTED_MODULE_0___default()(end, "DD-MM-YYYY").format("D MMM YYYY");
    if ((nStart === null || nStart === void 0 ? void 0 : nStart.slice(-4)) === (nEnd === null || nEnd === void 0 ? void 0 : nEnd.slice(-4))) {
        var length = nStart === null || nStart === void 0 ? void 0 : nStart.length;
        nStart = nStart === null || nStart === void 0 ? void 0 : nStart.slice(0, length - 5);
    }
    return "".concat(nStart, " - ").concat(nEnd);
};
var getSegmentCountries = function(list) {
    if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
        var ref;
        if ((list === null || list === void 0 ? void 0 : list.length) > 1) {
            var ref1;
            var c = (ref1 = list === null || list === void 0 ? void 0 : list.map(function(c) {
                return c === null || c === void 0 ? void 0 : c.name;
            })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2);
            return c === null || c === void 0 ? void 0 : c.join(", ");
        }
        return (ref = list[0]) === null || ref === void 0 ? void 0 : ref.name;
    }
    return "";
};
var calculateAge = function(dob) {
    var ageDifMs = Date.now() - moment__WEBPACK_IMPORTED_MODULE_0___default()(dob, "DD-MM-YYYY").toDate().getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
};
var getUserType = function(t) {
    if ((t === null || t === void 0 ? void 0 : t.length) > 0) {
        var ages = t === null || t === void 0 ? void 0 : t.map(function(param) {
            var dob = param.dob;
            return dob ? calculateAge(dob) : null;
        });
        var seniorCitizen = ages === null || ages === void 0 ? void 0 : ages.filter(function(a) {
            return a >= 60;
        });
        return (seniorCitizen === null || seniorCitizen === void 0 ? void 0 : seniorCitizen.length) > 0 ? "senior_citizen" : "";
    }
    return "";
};
var handleBrowserBack = function(router, handleBack) {
    if (!!router) {
        router === null || router === void 0 ? void 0 : router.beforePopState(function(param) {
            var as = param.as;
            if (as !== (router === null || router === void 0 ? void 0 : router.asPath)) {
                handleBack();
                return false;
            }
            return true;
        });
        return function() {
            router === null || router === void 0 ? void 0 : router.beforePopState(function() {
                return true;
            });
        };
    }
    return false;
};
function inputRegexValidation(text) {
    try {
        if (text.length === 0) {
            return false;
        }
        var regx = new RegExp("<|//|>|<iframe|http:|https:|@|$|#");
        if (regx.test(text)) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
}
function getFormattedDates(duration) {
    var startDateRegex = /\d{1,2} \w{3}(, \d{4})?/; // Matches day, month, and optional year pattern
    var endDateRegex = /\d{1,2} \w{3}, \d{4}/; // Matches day, month, and year pattern
    var startDateMatch = duration === null || duration === void 0 ? void 0 : duration.match(startDateRegex)[0];
    var startIndex = (duration === null || duration === void 0 ? void 0 : duration.indexOf("-")) + 1;
    var endDateMatch = duration === null || duration === void 0 ? void 0 : duration.substr(startIndex).match(endDateRegex)[0];
    var hasYear = startDateMatch === null || startDateMatch === void 0 ? void 0 : startDateMatch.includes(",");
    var startYear = hasYear ? moment__WEBPACK_IMPORTED_MODULE_0___default()(startDateMatch, "DD MMM, YYYY").format("YYYY") : moment__WEBPACK_IMPORTED_MODULE_0___default()(endDateMatch, "DD MMM, YYYY").format("YYYY");
    var endYear = moment__WEBPACK_IMPORTED_MODULE_0___default()(endDateMatch, "DD MMM, YYYY").format("YYYY");
    var startDate = moment__WEBPACK_IMPORTED_MODULE_0___default()("".concat(startDateMatch, " ").concat(startYear), "DD MMM YYYY").format("DD/MM/YYYY");
    var endDate = moment__WEBPACK_IMPORTED_MODULE_0___default()("".concat(endDateMatch, " ").concat(endYear), "DD MMM YYYY").format("DD/MM/YYYY");
    return {
        startDate: startDate !== "Invalid date" ? startDate : null,
        endDate: endDate !== "Invalid date" ? endDate : null
    };
}
var getQueryParams = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var utmSource = query === null || query === void 0 ? void 0 : query.utm_source;
    var singleUtmSource = "";
    var attrs = (ref = Object.keys(query).map(function(q) {
        return q !== "journeyId" && q !== "utm_source" && q !== "visaCountry" && q !== "urlRoot" ? "".concat(q, "=").concat(query[q]) : null;
    })) === null || ref === void 0 ? void 0 : ref.filter(function(a) {
        return !!a;
    });
    if (utmSource) {
        if (Array.isArray(utmSource) && (utmSource === null || utmSource === void 0 ? void 0 : utmSource.length) > 0) {
            singleUtmSource = "utm_source=".concat(utmSource[0]);
        } else singleUtmSource = "utm_source=".concat(query.utm_source);
        attrs === null || attrs === void 0 ? void 0 : attrs.push(singleUtmSource);
    }
    var params = attrs === null || attrs === void 0 ? void 0 : attrs.join("&");
    return params ? "?".concat(params) : "";
};
var getSessionQuery = function() {
    if (true) {
        // Getting previous params from session storage
        var queryString = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("routerQuery");
        var sessionQuery = !!queryString ? JSON === null || JSON === void 0 ? void 0 : JSON.parse(queryString) : {};
        var vasQueryString = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_segment_types__WEBPACK_IMPORTED_MODULE_1__/* .VAS.VAS_ROUTER_QUERY */ .xM.VAS_ROUTER_QUERY);
        var vasSessionQuery = !!vasQueryString ? JSON === null || JSON === void 0 ? void 0 : JSON.parse(vasQueryString) : {};
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, vasSessionQuery, sessionQuery);
    }
    return {};
};
// Login redirection
var redirectToLogin = function() {
    if (true) {
        var ref, ref1;
        var pathname = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "";
        var search = (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.search) || "";
        var nextRoute = pathname + search;
        window.location.href = "/login?next=".concat(encodeURIComponent(nextRoute));
    }
};
var convertDateToString = function(inputFormat) {
    var pad = function(s) {
        return s < 10 ? "0".concat(s) : s;
    };
    var d = new Date(inputFormat);
    return [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear()
    ].join("-");
};
var getMonth = function(input) {
    var d = new Date(input);
    if (!!d) {
        var month = (d === null || d === void 0 ? void 0 : d.getMonth()) + 1;
        return month < 10 ? "0".concat(month) : month;
    }
    return "";
};
var getYear = function(input) {
    var century = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var y = new Date(input);
    if (!!y) {
        var year = y === null || y === void 0 ? void 0 : y.getFullYear();
        return year - century * 100;
    }
    return "";
};
var getDomainHostname = function() {
    var prodUrl = "https://www.acko.com";
    var uatUrl = "https://www.ackodev.com";
    if (_api_constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCTION_ENVIRONMENT */ .H) return prodUrl;
    return uatUrl;
};
var getAtlPrice = function() {
    var original_price = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", multiplier = arguments.length > 1 ? arguments[1] : void 0;
    var currencyFormatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
    });
    var priceString = !!original_price ? original_price === null || original_price === void 0 ? void 0 : original_price.slice(1) : "";
    var filteredPrice = priceString === null || priceString === void 0 ? void 0 : priceString.replace(",", "");
    var price = !!filteredPrice ? Number(filteredPrice) : 0;
    return currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(Math.ceil(price * multiplier));
};
var getTripDurationLabel = function(selectedDateRange) {
    if ((selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.start) && (selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.end)) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var startDate = {
            y: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref = selectedDateRange.start) === null || ref === void 0 ? void 0 : ref.getFullYear(),
            m: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref1 = selectedDateRange.start) === null || ref1 === void 0 ? void 0 : ref1.getMonth(),
            d: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref2 = selectedDateRange.start) === null || ref2 === void 0 ? void 0 : ref2.getDate()
        };
        var endDate = {
            y: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref3 = selectedDateRange.end) === null || ref3 === void 0 ? void 0 : ref3.getFullYear(),
            m: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref4 = selectedDateRange.end) === null || ref4 === void 0 ? void 0 : ref4.getMonth(),
            d: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref5 = selectedDateRange.end) === null || ref5 === void 0 ? void 0 : ref5.getDate()
        };
        var label = "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[startDate === null || startDate === void 0 ? void 0 : startDate.m], ", ").concat(startDate === null || startDate === void 0 ? void 0 : startDate.y, " - ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[endDate === null || endDate === void 0 ? void 0 : endDate.m], ", ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.y);
        if ((startDate === null || startDate === void 0 ? void 0 : startDate.y) === (endDate === null || endDate === void 0 ? void 0 : endDate.y)) {
            label = "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[startDate === null || startDate === void 0 ? void 0 : startDate.m], " - ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[endDate === null || endDate === void 0 ? void 0 : endDate.m], ", ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.y);
        }
        return label;
    }
    return "";
};
var convertDateRange = function(dateRangeStr) {
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dateRangeStr === null || dateRangeStr === void 0 ? void 0 : dateRangeStr.split(" - "), 2), startStr = ref2[0], endStr = ref2[1];
    var startDateYear = (ref = startStr === null || startStr === void 0 ? void 0 : startStr.split(",")[1]) === null || ref === void 0 ? void 0 : ref.trim();
    var endDateYear = (ref1 = endStr === null || endStr === void 0 ? void 0 : endStr.split(",")[1]) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var startDate = startDateYear ? new Date(startStr) : new Date("".concat(startStr, ", ").concat(endDateYear));
    var endDate = new Date(endStr);
    return [
        startDate,
        endDate
    ];
};


/***/ })

}]);